module.exports = __webpack_public_path__ + "static/slide1@2x-b6a2bfd07167ee4f4b7c4ea6b8846401.png";